import { UserIcon } from "@heroicons/react/outline";
import { DotsVerticalIcon } from "@heroicons/react/solid";
import Container from "../../components/container/Container";
// import ProfileRoomsCard from "../../components/ProfileRoomsCard/ProfileRoomsCard";
import RoomsCardData from "../../components/RoomsCardData/RoomsCardData";
import { auth } from "../../database/firebase";
import useUserRooms from "../../hooks/DatabseCollection/useUserRooms";

const Profilepage = () => {
  // const { userId } = useParams();
  const user = auth.currentUser;
  const { userRooms } = useUserRooms(user.uid);

  return (
    <Container>
      <div>
        <div className="bg-white w-[50%] mt-10 border border-gray-300 shadow rounded-sm py-5">
          <div className="px-3 flex space-x-5">
            <div>
              {user.photoURL ? (
                <img
                  src={user.photoURL}
                  alt=""
                  className=" h-32 w-40 rounded-full border border-gray-300 shadow"
                />
              ) : (
                <UserIcon className="h-32 w-32 px-7 bg-gray-50 rounded-full border border-gray-300 shadow" />
              )}
            </div>
            <div className="flex flex-col w-full space-y-2">
              <div className="flex  justify-between items-center">
                <h1 className="font-semibold tracking-wider">
                  {user.displayName}
                </h1>
                <DotsVerticalIcon className="h-5 text-gray-400" />
              </div>
              <p className="font-semibold text-gray-400">{user.email}</p>
              <span className="text-xs font-semibold text-gray-400">
                India, Bangalore
              </span>
              <span className="text-xs font-semibold text-gray-400">Admin</span>
              <div className="flex justify-end">
                <button
                  onClick={() => auth.signOut()}
                  className="border px-4 text-xs py-1 shadow focus:outline-none border-gray-300"
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5">
          <h1 className="font-semibold ml-2">My Rooms</h1>
          {userRooms.length > 0 ? (
            <div>
              {userRooms.map(
                ({
                  id,
                  data: { roomName, createdUser, privacyMode, language },
                }) => (
                  <RoomsCardData
                    key={id}
                    roomId={id}
                    title={roomName}
                    createdUser={createdUser}
                    language={language}
                  />
                )
              )}
            </div>
          ) : (
            <h1>no rooms</h1>
          )}
        </div>
      </div>
    </Container>
  );
};

export default Profilepage;
